import BaseOverlay from './base-overlay.js';
import { createFocusTrap } from 'focus-trap';

export default class Modal extends BaseOverlay {
    constructor() {
        super();
        this.focusTrap = null;
    }

    connectedCallback() {
        super.connectedCallback();
        this.initFocusTrap();
        this.setupCloseButtons();
    }

    setupCloseButtons() {
        const cleanup = this.delegateClick('.modal__close', (match, evt) => {
            evt.preventDefault();
            this.close();
        });
        this._delegatedCleanupFunctions.push(cleanup);
    }

    initFocusTrap() {
        this.focusTrap = createFocusTrap(this, {
            allowOutsideClick: true,
            escapeDeactivates: true,
            fallbackFocus: this,
            initialFocus: () => {
                return (
                    this.querySelector('[autofocus]') ||
                    this.querySelector('.modal__close') ||
                    this.querySelector('button, [tabindex="0"]') ||
                    this
                );
            }
        });
    }

    shouldCloseOnOutsideClick() {
        return true;
    }

    getContentElement() {
        return this.querySelector('.modal__content');
    }

    onOpen() {
        this.setAttribute('aria-modal', 'true');
        this.setAttribute('role', 'dialog');

        if (this.focusTrap) {
            this.focusTrap.activate();
        }
    }

    onClose() {
        this.removeAttribute('aria-modal');

        if (this.focusTrap && this.focusTrap.active) {
            this.focusTrap.deactivate();
        }
    }

    destroy() {
        if (this.focusTrap) {
            this.focusTrap.deactivate();
        }
        super.destroy();
    }
}

customElements.define('modal-dialog', Modal);
